import { ERROR, RESET, START, SUCCESS } from './constants';
import HttpV2 from '../../httpv2';

export const resetValidation = () => ({
  type: RESET,
});

export const validateSale = () => ({ type: START });

export const validateSaleSuccess = payload => ({
  type: SUCCESS,
  payload,
});

export const validateSaleError = () => ({ type: ERROR });

export const validateShopSale = (id, order) => (
  HttpV2.post(
    `/shop/${id}/sale/validate`,
    order,
    true,
    {
      'Squire-Version': '2023-11-12',
    },
  )
);

export const validateBarberSale = (id, order) => (
  HttpV2.post(
    `/barber/${id}/sale/validate`,
    order,
    true,
    {
      'Squire-Version': '2023-11-12',
    },
  )
);
